// API token service — talks to /v1/api-tokens on the tickets API.
import { apiClient } from '../api-client';
import { API_TOKENS } from '../../api-endpoints/api-endpoints';

export interface ApiTokenRow {
  id: string;
  name: string;
  masked: string;
  scopes: string[];
  lastUsedAt: string | null;
  expiresAt: string | null;
  createdAt: string;
}

export interface CreatedApiToken extends ApiTokenRow {
  /** Plaintext — returned ONCE on creation only. */
  token: string;
}

export const apiTokensService = {
  list: async (): Promise<ApiTokenRow[]> => {
    const res = await apiClient.get<{ data: ApiTokenRow[] }>(API_TOKENS.list);
    return res?.data ?? [];
  },
  create: (input: { name: string; scopes: string[]; expiresAt?: string | null }): Promise<CreatedApiToken> =>
    apiClient.post<CreatedApiToken>(API_TOKENS.create, input),
  update: (id: string, input: { name: string }): Promise<ApiTokenRow> =>
    apiClient.patch<ApiTokenRow>(API_TOKENS.update(id), input),
  revoke: (id: string): Promise<void> => apiClient.delete<void>(API_TOKENS.revoke(id)),
};
